import { useState } from 'react';

/** Column widths the reader has dragged, by the column's data key. */
export type ColumnWidthsByKey = ReadonlyMap<string, number>;

/**
 * Column widths the reader has dragged, held by the page — above the grid,
 * which is remounted around every refetch and unmounted outright while no
 * division is selected (the first click of a double-click on the only selected
 * division) — so a division, page or view switch keeps the columns where they
 * were put. Keyed by column, not position, so a width follows its column
 * between views that share it (ITEMNO on more than one worksheet).
 */
export function useColumnWidths(): {
  columnWidths: ColumnWidthsByKey;
  rememberColumnWidth: (dataKey: string, width: number) => void;
} {
  const [columnWidths, setColumnWidths] = useState<Map<string, number>>(
    () => new Map(),
  );
  const rememberColumnWidth = (dataKey: string, width: number) =>
    setColumnWidths((prev) => new Map(prev).set(dataKey, width));
  return { columnWidths, rememberColumnWidth };
}
